import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import DownloadService from '@/utils/download'
import downloadUtil from '@/utils/downloadUtil'

const state = {
  message: {
    content: '',
    type: ''
  },
  masterList: [],
  masterName: {
    'm_item_category_for_company.csv.zip': '分類マスタ',
    'm_item_for_company.csv.zip': '商品マスタ',
    'm_store.csv.zip': '店舗マスタ'
  }
}

const actions = {

  async getInitData ({ dispatch, state, commit }) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    let type = 'success'
    const response = await ApiManager.request('AnalyzeMaster').analyzeMasterList()
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setMasterList', response.data.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    this.dispatch('loading/loadingPageMinus')
    return response.data.data
  },
  /**
   * ダウンロードを実行する
   */
  async download ({ state, commit }, slug) {
    this.dispatch('loading/loadingPagePlus')
    commit('init')
    const response = await DownloadService.downloadAnalyzeMaster(slug)
    commit('setMasterFile', { data: response, name: slug })
  }
}

const mutations = {
  init (state, data) {
    state.message = {
      content: '',
      type: ''
    }
  },
  setMessage (state, data) {
    state.message = data
  },
  setMasterList (state, data) {
    state.masterList = data
  },
  setMasterFile (state, data) {
    downloadUtil(data.data, data.name)
    this.dispatch('loading/loadingPageMinus')
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
